export default __webpack_public_path__ + "static/media/Icon material-search.72bcd81e.svg";